/* src/app/modules/patternmatch/components/mrq-table/mrq-table.component.scss */
.mrq-table-container {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
}
.loading-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  padding: 2rem;
}
.table-container {
  max-height: 500px;
  overflow-y: auto;
  overflow-x: auto;
}
.mat-table-container {
  width: 100%;
}
.mat-table-container table {
  width: 100%;
}
.mat-table-container table th.mat-header-cell,
.mat-table-container table th.mat-mdc-header-cell {
  color: var(--sh-neutral-900, #212121);
  font-weight: 600;
  padding: 12px 16px;
  text-align: left;
  position: sticky;
  top: 0;
  z-index: 2;
  box-sizing: content-box;
}
.mat-table-container table th.mat-header-cell:first-child,
.mat-table-container table th.mat-mdc-header-cell:first-child {
  position: sticky;
  left: 0;
  top: 0;
  z-index: 3;
  background-color: white;
}
.mat-table-container table td.mat-cell:first-child,
.mat-table-container table td.mat-mdc-cell:first-child {
  position: sticky;
  left: 0;
  z-index: 1;
}
.mat-table-container table td.mat-cell:first-child:not(.weekend-cell),
.mat-table-container table td.mat-mdc-cell:first-child:not(.weekend-cell) {
  background-color: white;
}
.mat-table-container table td.mat-cell {
  padding: 12px 16px;
  border-bottom: 1px solid var(--sh-neutral-200, #d9dde0);
}
.mat-table-container table tr.mat-row {
  height: 48px;
}
.mat-table-container table tr.mat-row:hover {
  background-color: var(--sh-neutral-50, #f5f5f5);
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  width: 100%;
  padding: 2rem;
}
.table-header-text {
  font-weight: bold;
}
.weekend-cell {
  background-color: #f2f2f2;
  color: #212121;
}
/*# sourceMappingURL=mrq-table.component.css.map */
